<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 9586 9586"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="4793" cy="4793" r="4793" />
   <g id="_721201064">
   <path class="fil1"
         d="M2527 2418l4549 0c349,0 378,361 410,554 48,289 417,2291 417,2518 0,235 -215,394 -453,394l-5317 0c-179,0 -322,-82 -388,-203 -92,-170 -55,-287 -22,-484 56,-337 121,-680 177,-1023 55,-333 119,-674 174,-1007 47,-282 42,-749 453,-749zm-1260 3052c0,458 370,827 827,827l5395 0c235,0 445,-101 566,-221 354,-349 277,-708 190,-1165l-337 -1947c-27,-162 -48,-343 -104,-467 -118,-262 -396,-492 -650,-492l-4686 0c-284,0 -576,239 -681,480 -58,133 -520,2776 -520,2985z" />
     <path class="fil1"
           d="M4260 6750c0,83 -14,110 -16,159 -7,252 97,218 -109,268 -53,13 -100,29 -145,52 -287,144 -449,413 -478,761l2559 0c0,-225 -97,-439 -211,-556 -120,-124 -284,-270 -517,-270l0 -611 -1083 0 0 197z" />
     <path class="fil1"
           d="M3945 5254c504,337 -154,275 1378,275 52,0 244,-202 282,-249 74,-91 12,-301 14,-499 0,-95 -17,-447 -44,-488 -12,-18 -267,-240 -311,-240l-906 0c-72,0 -93,26 -133,63 -45,42 -63,52 -107,90 -199,170 -116,145 -134,477 -4,86 -17,82 -20,176 -2,65 3,134 1,198 -3,100 -20,99 -20,197z" />
     <path class="fil1"
           d="M6229 5529l1004 0c57,0 267,-224 286,-286 16,-48 -54,-420 -64,-487 -76,-518 -10,-405 -267,-599 -57,-44 -110,-104 -191,-104l-906 0c-58,0 -113,87 -155,121 -226,181 -127,125 -121,667 1,113 21,135 20,255 -2,218 36,146 222,330 51,50 79,103 172,103z" />
     <path class="fil1"
           d="M2192 4309c0,150 -37,326 -62,469 -24,148 -42,331 -75,476 459,307 -283,275 1339,275 49,0 60,-32 94,-63 38,-34 49,-36 88,-70 74,-66 86,-84 172,-142l59 -926c-36,-53 -246,-275 -315,-275l-925 0c-60,0 -272,201 -375,256z" />
     <path class="fil1"
           d="M2311 3659c0,5 195,236 256,236l945 0c48,0 248,-178 334,-236 0,-745 138,-703 -98,-886 -55,-43 -88,-99 -177,-99l-788 0c-76,0 -305,166 -334,197 -61,64 -83,368 -96,456 -16,117 -42,213 -42,332z" />
     <path class="fil1"
           d="M4319 3895l945 0c61,0 177,-137 295,-216 0,-241 -16,-256 -20,-394 -2,-70 5,-147 1,-217 -5,-89 -20,-93 -20,-197 -433,-229 131,-197 -1122,-197 -76,0 -240,128 -293,181 -66,67 -38,76 -42,193 -4,88 -20,109 -20,216 -1,421 -88,357 138,533 38,29 95,98 138,98z" />
     <path class="fil1"
           d="M5717 2871l30 659c21,153 9,137 116,219 41,32 168,146 208,146l945 0c56,0 146,-130 276,-216l-98 -631c-36,-226 -27,-150 -239,-312 -43,-33 -62,-62 -135,-62l-827 0c-56,0 -172,128 -276,197z" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'FVEPowerStation',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
